var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRiskLow = function SvgRiskLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1 10.5V9c0-1.67.51-3.22 1.38-4.5m14.62 6V9c0-1.67-.51-3.22-1.38-4.5M13.5 2.38a7.96 7.96 0 0 0-9 0",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M11.38 13.78c.52.8.2 1.95-.73 2.55-.93.6-2.1.43-2.63-.38-.52-.81-3.5-7.07-2.57-7.67.93-.6 5.41 4.69 5.93 5.5Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgRiskLow;